import { MAX_WORKFLOW_LOG_CAPTURE_BYTES } from '@shared/workflow/maxWorkflowLogCaptureBytes.js';

const CAPTURE_LIMIT_MB = Math.round(MAX_WORKFLOW_LOG_CAPTURE_BYTES / (1024 * 1024));

/**
 * Whether a run's actions can be replayed, with the user-facing reason when they
 * cannot. Replay needs a finished run whose log was captured in full.
 */
const getReplayAvailability = (log) => {
  if (!log?.finishedOn) {
    return { disabled: true, title: 'Replay is available once the run finishes.' };
  }

  if (log.meta?.logUploadStatus === 'uploading' || log.meta?.logUploadStatus === 'failed') {
    return { disabled: true, title: 'Replay requires a completed log upload.' };
  }

  const fullLogCapture = log?.meta?.fullLogCapture;
  if (fullLogCapture?.enabled !== true) {
    return {
      disabled: true,
      title: 'Replay requires full run logs, which are off for this organization. Runs started after "Capture Full Run Logs" is enabled are replayable.'
    };
  }

  if (fullLogCapture?.capReached === true) {
    return {
      disabled: false,
      title: `Replay actions from this run. This run hit the ${CAPTURE_LIMIT_MB} MB capture limit, so some actions may not be replayable.`
    };
  }

  return { disabled: false, title: 'Replay actions from this run using its captured data' };
};

export default getReplayAvailability;
